'use client';

import React, { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import LoginPage from '@/components/LoginPage';
import { useRouter } from 'next/navigation';
import Spinner from '@/components/Spinner';

export default function HomePage() {
  const { isLoggedIn, login } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (isLoggedIn) {
      router.replace('/dashboard-au');
    }
  }, [isLoggedIn, router]);

  if (!isLoggedIn) {
    return <LoginPage onLogin={login} />;
  }

  return (
    <div className="h-screen w-full flex items-center justify-center bg-background">
      <Spinner />
    </div>
  );
}
